module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp13_7005.d31dbf36.png";